import { getPosDevices, pickDefaultPosDevice } from './reservationsApi';

// Los lectores de tarjeta (docs/spec-caja.md, F1 / D-03 del backend): cada cobro con tarjeta dice
// por cuál aparato entró, o el cierre de lote de cada uno no se puede conciliar. Cafetería, retail
// y la cuenta de mesa ya lo hacían; esto lo comparten las pantallas que cobraban sin lector
// (entradas, membresías, mesa abierta y el walk-in de reservas).

/**
 * Lector preseleccionado en lo que se vende en el mostrador de la tienda (entradas, membresías):
 * el "Lector Tienda". Queda visible para cambiarlo.
 */
export function pickStorePosDevice(devices) {
  if (!Array.isArray(devices) || devices.length === 0) return null;
  return devices.find((d) => /tienda/i.test(d.name))
    || devices.find((d) => !/cafeter/i.test(d.name))
    || devices[0];
}

// El default es por canal (spec-caja Q-02): la tienda para el mostrador; para lo que se cobra en
// una mesa, el de cafetería, que es el del salón (el mismo que preseleccionan salón y reservas).
export const pickSalonPosDevice = pickDefaultPosDevice;

/**
 * Carga los lectores activos y elige el preseleccionado. Devuelve `{ posDevices, posDeviceId }`,
 * listo para `setState`. Nunca tira: sin lectores el cobro funciona igual (el backend guarda el
 * lector en null), sólo se pierde por cuál aparato entró.
 */
export async function loadPosDevices(pick = pickStorePosDevice) {
  try {
    const devices = await getPosDevices();
    const posDevices = Array.isArray(devices) ? devices : [];
    const preferido = pick(posDevices);
    return { posDevices, posDeviceId: preferido ? String(preferido.id) : '' };
  } catch (e) {
    return { posDevices: [], posDeviceId: '' };
  }
}

/**
 * El campo del cuerpo del cobro: sólo con tarjeta y con un lector elegido. Con otro medio no se
 * manda (el backend lo descartaría igual: guardarlo descuadraría el lote de ese aparato).
 */
export function posDeviceField(isCard, posDeviceId) {
  return isCard && posDeviceId ? { posDeviceId: Number(posDeviceId) } : {};
}
